import i18n from '@/helper/i18n';

export default function formatVoucherType(value) {
  return i18n.te(`vouchers.voucherTypes.${value}`)
    ? i18n.t(`vouchers.voucherTypes.${value}`)
    : value;
}
